import React from 'react'

function Ratings({classes, ratings}) {
    var rating = parseFloat(ratings)
    const totalStars = 5;
    const fullStars = Math.floor(rating); // Number of full stars
    const hasHalfStar = rating % 1 !== 0; // Check if there is a half star

    const starsArray = Array.from({ length: totalStars }, (_, index) => {
        if (index < fullStars) {
        return "full";
        } else if (index === fullStars && hasHalfStar) {
        return "half";
        } else {
        return "empty";
        }
    });
  return (
    <>
        {starsArray.map((type, index) => {
            if (type === "full") {
                return (<svg key={index} xmlns="http://www.w3.org/2000/svg" fill="currentColor" className={`bi bi-star-fill ${classes}`} viewBox="0 0 16 16">
                    <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"/>
                  </svg>)
            } else if (type === "half") {
                return (<svg key={index} xmlns="http://www.w3.org/2000/svg" fill="currentColor" className={`bi bi-star-half ${classes}`} viewBox="0 0 16 16">
                    <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"/>
                  </svg>)
            } else {
                return (<svg key={index} xmlns="http://www.w3.org/2000/svg" fill="currentColor" className={`bi bi-star ${classes}`} viewBox="0 0 16 16">
                    <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"/>
                  </svg>)
            }
        })}        
    </>
  )
}

export default Ratings